<template>
  <div id="app">
    <header class="header">
      <div class="ui menu">
        <div class="ui container">
          <template v-for="menu of menus">
            <div class="ui simple dropdown item" :key="menu.id" v-if="menu.children.length">
              {{menu.title}}
              <i class="dropdown icon"></i>
              <div class="menu">
                <template v-for="item of menu.children">
                  <div class="item" :key="item.id" v-if="item.children.length">
                    <i class="dropdown icon"></i>
                    <span class="text">{{item.title}}</span>
                    <div class="menu">
                      <template v-for="child of item.children">
                        <a v-if="child.uri.startsWith('http')" class="item" :href="child.uri" :key="child.id" target="_blank">{{child.title}}</a>
                        <router-link v-else class="item" :key="child.id" :to="child.uri">{{child.title}}</router-link>
                      </template>
                    </div>
                  </div>
                  <template v-else>
                    <a v-if="item.uri.startsWith('http')" class="item" :href="item.uri" :key="item.id" target="_blank">{{item.title}}</a>
                    <router-link v-else class="item" :key="item.id" :to="item.uri">{{item.title}}</router-link>
                  </template>
                </template>
              </div>
            </div>
            <template v-else-if="menu.uri">
              <a v-if="menu.uri.startsWith('http')" class="item" :href="menu.uri" :key="menu.id" target="_blank">{{menu.title}}</a>
              <router-link v-else class="item" :key="menu.id" :to="menu.uri">{{menu.title}}</router-link>
            </template>
          </template>

          <div class="right menu">
            <div class="item" v-if="!user.authenticated">
              <router-link :to="'/login?return=' + $route.path">Login</router-link>
            </div>
            <div class="ui simple dropdown item" v-if="user.authenticated">
              {{ user.name }}
              <i class="dropdown icon"></i>
              <div class="menu">
                <router-link class="item" to="/message">
                  我的消息
                  <div class="ui tiny red label" v-if="unreadCount">{{unreadCount}}</div>
                </router-link>
                <router-link class="item" to="/user">用户信息</router-link>
                <router-link class="item" to="/user/weibo">微博账号</router-link>
                <router-link class="item" to="/admin" v-if="user.isAdmin">管理中心</router-link>
              </div>
            </div>
            <div class="item" v-if="user.authenticated">
              <a href="#" @click.prevent="logout">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main>
      <transition name="fade">
        <div class="ui message" v-if="message">
          <a :href="message.url" :title="message.title" target="_blank">{{message.content}}</a>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>

    <footer class="ui footer inverted" v-if="icpBeian||govBeian">
      <div class="ui center aligned container">
        <div class="ui inverted horizontal link list">
          <a href="http://beian.miit.gov.cn/" class="item" target="_blank" v-if="icpBeian">{{icpBeian}}</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo" class="item"
             v-if="govBeian">
            <img alt="beian" src="/beian.png" style="width: 16px;">
            <span>{{govBeian}}</span>
          </a>
        </div>
      </div>
    </footer>

  </div>
</template>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  main {
    padding-bottom: 36px;
  }
  .message {
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .ui.footer {
    z-index: 999;
  }
  .ui.inverted.footer {
    background: #1b1c1d;
    color: hsla(0,0%,100%,.9);
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>

<script>
  import axios from 'axios';
  import auth from './services/Auth';
  import EventBus from './services/event-bus';

  export default {
    name: 'app',
    mounted () {
      console.log('向阳而生，超越一切！')
      console.log('欢迎村村芽芽^_^')
      this.user = auth.user;
      this.id = Math.floor(Math.random() * 10) + 1;
      const width = window.innerWidth;
      if (width < 1400) {
        setTimeout(() => {
          this.show = false;
          this.id = 0;
        }, 5000);
      }
      this.loadGlobalConfig(1);
      this.timers.push(setInterval(this.loadGlobalConfig, 60000));
      this.timers.push(setInterval(this.nextMessage, 6000));
      EventBus.$on('login', (data) => {
        this.user = data;
        this.loadMenus();
        this.getUnreadCount();
      });
      EventBus.$on('message', () => {
        this.getUnreadCount();
      });
      EventBus.$on('menus', () => {
        this.loadMenus();
      });
    },
    destroyed() {
      this.timers.forEach(e => {
        clearInterval(e);
      })
    },
    data () {
      return {
        icpBeian: '',
        govBeian: '',
        user: {},
        id: 0,
        index: 0,
        unreadCount: 0,
        timers: [],
        notifications: [],
        message: null,
        show: true,
        menus: [],
      }
    },
    watch: {
      '$route.path' (value) {
        this.show = value && !value.startsWith('/admin/');
        if (this.id > 0) {
          this.id = Math.floor(Math.random() * 10) + 1;
        }
      }
    },
    methods: {
      loadGlobalConfig(init = 0) {
        axios.get('/config/global?init=' + init).then(({data}) => {
          this.notifications = data.notifications
          this.menus = data.menus
          this.icpBeian = data.icpBeian
          this.govBeian = data.govBeian
          this.unreadCount = data.unreadCount
          if (data.siteName) {
            document.title = data.siteName
          }
        })
      },
      getUnreadCount() {
        axios.get('/messages/unread').then(({data}) => {
          this.unreadCount = data
        })
      },
      loadMenus() {
        axios.get('/menus').then(({data}) => {
          this.menus = data;
        })
      },
      nextMessage() {
        if (this.notifications.length) {
          this.index++;
          this.message = this.notifications[this.index % this.notifications.length];
        }
      },
      logout () {
        auth.logout();
        this.loadMenus();
      }
    }
  }
</script>
